module.exports = __webpack_public_path__ + "static/img/baas_product_2.454ca0d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_product_2.svg
// module id = 02i4
// module chunks = 0